module.exports = __webpack_public_path__ + "resources/img/img_voice_studio1_m.64ed32c6f5d636826712eff059efd4d8.png";